import { MultipleItemResponse, fetchContent } from './fetchContent'
import { RolexProductPageV72024 } from './models/RolexProductPageV72024'

type Props = {
  language: string
  fid: string
  skip?: number
  limit?: number
}

export async function fetchRolexV7Products({ language, fid, skip = 0, limit = 6 }: Props) {
  const products: MultipleItemResponse<RolexProductPageV72024> = await fetchContent({
    path: '',
    params: {
      elements: ['url_slug', 'main_image', 'short_description', 'title', 'order_overall'],
      'system.type[in]': ['rolex_product_page_v7_2024'],
      'elements.rolex_family[any]': fid,
      order: 'elements.order_overall',
      language,
      limit,
      skip,
      includeTotalCount: true,
    },
  })

  return products
}
